<svelte:options customElement={{ tag: "bt-lesson-topbar", shadow: "none" }} />

<script lang="ts">
	import { onMount } from 'svelte';
	import { eventBus } from '$shared/lib/eventBus';

	import Icon from '$shared/icons/Icon.svelte';
	import ProgressBar from '$shared/progress-bar/ProgressBar.svelte';
	import { SIDEBAR_BREAKPOINT } from '$comp/lessons/sidebar/LessonSidebarConsts';

	export let visible = false;
	export let UID: string = '';
	export let associatedSidebarUID: string = '';
	export let contentTypeText: string = '';
	export let openTOCText: string = '';
	export let completeText: string = '';

	let pathName: string = ' ';
	let pathDuration: string = ' ';
	let pathProgress: string | number = 0;
	let initialized: boolean = false;

	// Force path progress to type number
	pathProgress = +pathProgress;

	const sendOpenSidebar = (uid) => {
		eventBus.emit('sidebar-open', {
			targetUID: associatedSidebarUID
		})
		visible = false;
	}

	onMount(() => {
		if (window.innerWidth <= SIDEBAR_BREAKPOINT) {
			visible = true;
		}
		eventBus.on('topbar-initialize', (event) => {
			if (event.targetUID !== UID) {
				return;
			}
			pathName = event.contentGroupData.group_name;
			pathDuration = event.contentGroupData.group_duration;
			pathProgress = +event.contentGroupData.group_progress;
			initialized = true;
		});
		eventBus.on('topbar-open', (event) => {
			if (event.targetUID !== UID) {
				return;
			}
			visible = true;
		})
		return () => {
			eventBus.off('topbar-open');
		}
	});

</script>

<section class={`topbar ${visible ? '' : 'hidden'} ${initialized ? '' : ''}`}>
	<div class="topbar__button-and-meta">
		<label class="topbar__button">
			<span class="sr-only">{openTOCText}</span>
			<button type="button" class="topbar__sidebar-toggle" on:click={sendOpenSidebar}>
				<Icon icon="ListVideo" size="medium"></Icon>
			</button>
		</label>
		<div class="topbar__meta">
		  <span class="text-neutral-500 tracking-[1px] text-xs uppercase block">{contentTypeText}</span>
		  <span class="font-medium block leading-[1.5]" style="min-height: 24px;">{pathName}</span>
		  <span class="text-neutral-500 block text-xs" style="min-height: 16px;">{pathDuration}</span>
		</div>
	</div>
	<div class="topbar__progress">
      <ProgressBar color="yellow" numerator={pathProgress} denominator={100}></ProgressBar>
      <span class="block text-xs text-neutral-800 font-medium lowercase">{pathProgress}% {completeText}</span>
	</div>
</section>

<style>
	.topbar {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		row-gap: 30px;
		margin-bottom: 1rem;
		&.hidden {
			display: none;
		}
		&:not(.initialized) {
			opacity: 1;
		}
	}

	/* Gross, but necessary to override the space-y-6 helper from tw */
	:global(bt-lesson-topbar + div) {
		margin-top: 0 !important;
	}

	.topbar__sidebar-toggle {
		display: grid;
		width: 40px;
		height: 40px;
		padding: 10px;
		margin-right: .5rem;
		border: none;
		border-radius: theme('borderRadius.lg');
		background: white;
		box-shadow: 0px 28px 8px 0px rgba(59, 59, 59, 0.00), 0px 18px 7px 0px rgba(59, 59, 59, 0.01), 0px 10px 6px 0px rgba(59, 59, 59, 0.05), 0px 4px 4px 0px rgba(59, 59, 59, 0.09), 0px 1px 2px 0px rgba(59, 59, 59, 0.10);
		place-content: center;
		&:hover {
			cursor: pointer;
		}
	}
	.topbar__button-and-meta {
		display: grid;
		grid-template-rows: 1;
		grid-template-columns: 2;
		flex-shrink: 0;
		max-width: 100%;
	}
	.topbar__button {
		display: grid;
		grid-column: 1 / span 1;
		place-content: center;
	}
	.topbar__meta {
		display: flex;
		grid-column: 2 / span 1;
		flex-direction: column;
		justify-content: space-around;
	}
	.topbar__progress {
		display: flex;
		flex-basis: 18rem;
		flex-shrink: 1;
		flex-direction: column;
		justify-content: space-around;
	}
</style>
